import React, { useState } from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  TableWrapper,
  TableAction,
  ModalDeleteConfirm,
  TableCellDefault,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";
import { useFetch, useDatatables } from "App/hooks";
import {
  ModalForm,
  headCells,
  deletePoliklinikById,
  RESET_STATE_POLIKLINIK,
} from "./helpers";

import { TYPE_INSTANCE1 } from "App/constants";
import { scrollToTop } from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

export default function Poliklinik() {
  const classes = STYLE_DEFAULT_MASTER();
  const [rows, setRows] = useFetch(
    TYPE_INSTANCE1,
    LIST_URL_MASTER.poliklinik.list
  );

  const [formData, setFormData] = useState(RESET_STATE_POLIKLINIK);

  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name", "code"],
  });

  // function clickAdd() {
  //   setFormData({ id: "", name: "", code: "", no_poli: "" });
  // }

  function clickUpdate(row) {
    scrollToTop();
    setFormData({
      id: row?.id,
      name: row?.name,
      code: row?.code,
      no_poli: row?.no_poli,
      poliklinik: row?.poliklinik,
      kodebridge: row?.kodebridge,
    });
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  return (
    <div
      className={classes.root}
      style={{
        marginTop: "2rem",
      }}>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deletePoliklinikById(
              formData.id,
              setRows,
              setShowModalDeleteConfirm,
              setFormData
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <ModalForm
        setRows={setRows}
        formData={formData}
        setFormData={setFormData}
      />
      <div className='mt-1'>
        <TableWrapper
          title='Daftar Poliklinik'
          setQ={setQ}
          withAddButton={false}
          withExportButton={false}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={rows}
          headCells={headCells}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}>
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                  }}>
                  <TableCell
                    component='th'
                    scope='row'
                    padding='none'
                    align='center'>
                    {index + 1}
                  </TableCell>

                  <TableCell
                    component='th'
                    scope='row'
                    padding='none'
                    align='center'>
                    <TableAction
                      clickDelete={() => clickDelete(row)}
                      clickUpdate={() => clickUpdate(row)}
                    />
                  </TableCell>
                  <TableCell align='left'>{row?.code}</TableCell>

                  <TableCell align='left'>{row?.name}</TableCell>
                  <TableCell align='left'>{row?.no_poli}</TableCell>
                  <TableCell align='left'>{row?.kodebridge}</TableCell>
                  <TableCell align='left'>{row?.remark}</TableCell>

                  <TableCellDefault row={row} />
                </TableRow>
              );
            })}
        </TableWrapper>
      </div>
    </div>
  );
}
